import { css } from 'styled-components'

/**
 * CSS mixins — styled-components `css` fragments that can be composed into any
 * `styled()` component regardless of its base element (Card, Flex, WeenatPressable…).
 *
 * Usage:
 *   const MyComponent = styled(SomeBase)`
 *     ${interactiveHover}
 *     // additional styles…
 *   `
 *
 * Two variants:
 *   - `interactiveHover`           — for bordered elements (cards) : border primary + shadow
 *   - `interactiveBackgroundHover` — for borderless elements (nav links) : background primary
 */

/** Hover for elements with borders (cards) : border primary + shadow. */
export const interactiveHover = css`
  cursor: pointer;
  transition:
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
  will-change: border-color, box-shadow;

  &:hover {
    border-color: ${(p) => p.theme.colors.primary[500]};
    box-shadow: ${(p) => p.theme.shadows.sm.boxShadow};
  }
`

/** Hover for elements without (nav links, list items) : background primary. */
export const interactiveBackgroundHover = css`
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  will-change: background-color;

  &:hover {
    background-color: ${(p) => p.theme.colors.primary[200]};
  }
`
